import {
  BackIcon,
  CalendarDateIcon,
  CandidateIcon,
  CustomerTitleIcon,
  EmailIcon,
  GraphIcon,
  GroupTitleIcon,
  HomeIcon,
  InterviewTitleIcon,
  ProjectTitleIcon,
  SystemIcon,
  UserTitleIcon,
} from './icons'

// const getUrl = url => `${process.env.REACT_APP_PER1_URL}/it/${url}`

export const menuItemlite = ({ tenant }) => [
  {
    title: 'menu.users',
    key: 'users',
    icon: UserTitleIcon,
    url: '/users',
  },
  {
    title: 'global.back',
    key: 'goBack',
    icon: BackIcon,
    onClick: () => {
      window.location.href = `//${tenant.dominio}`
    },
  },
]

// use permission name as key (candidates:read) or set permission name manually

export const menuItems = [
  {
    title: 'global.dashboard',
    key: 'home',
    icon: HomeIcon,
    url: '/home',
    permission: 'home',
    // count: 4
  },
  {
    title: 'menu.nominatives',
    key: 'candidates',
    icon: CandidateIcon,
    url: '/candidates',
  },
  {
    title: 'candidati.projects',
    key: 'projects',
    icon: ProjectTitleIcon,
    url: '/projects',
  },
  {
    title: 'candidati.projects',
    key: 'seller-projects',
    icon: ProjectTitleIcon,
    url: '/seller-projects',
    permission: 'seller-projects:read',
  },
  {
    title: 'menu.interview',
    key: 'interview',
    icon: InterviewTitleIcon,
    url: '/candidates-interview/0',
    permission: 'candidates:read',
    tenantIds: [340],
  },
  {
    title: 'customers.customers',
    key: 'customers',
    icon: CustomerTitleIcon,
    url: '/customers',
  },
  {
    title: 'menu.calendar',
    key: 'calendar',
    icon: CalendarDateIcon,
    url: '/calendar',
  },
  {
    title: 'menu.graphics',
    key: 'stats',
    permission: 'stats',
    icon: GraphIcon,
    children: [
      {
        title: 'menu.graphics',
        key: 'stats.graphics',
        url: '/graphics',
      },
      {
        title: 'menu.candidate_analysis',
        key: 'stats.candidates',
        url: '/candidate-analysis',
      },
      {
        title: 'menu.channel_analysis',
        key: 'stats.channels',
        url: '/channels-analysis',
      },
      {
        title: 'menu.project_analysis',
        key: 'stats.projects',
        url: '/projects-analysis',
      },
      {
        title: 'menu.candidature_analysis',
        key: 'stats.nominations',
        url: '/candidature-analysis',
      },
      /* {
          title: 'menu.classes_analysis',
          key: 'stats.courses',
          url: '/graphics',
        }, */
    ],
  },
  {
    title: 'global.email',
    key: 'email',
    icon: EmailIcon,
    children: [
      /* { REVISAR
          title: 'Email inbox',
          key: 'projects.projects',
          url: '/projects',
        }, */
      {
        title: 'global.email_template',
        key: 'email.template',
        url: '/email-template',
      },
      {
        title: 'email.email_sent',
        key: 'email.email_sent',
        url: '/email-sent',
      },
    ],
  },
  {
    title: 'users.working_groups',
    key: 'groups',
    icon: GroupTitleIcon,
    url: '/groups',
    roles: ['ROLE_ADMIN'],
  },
  {
    title: 'menu.users',
    key: 'users',
    icon: UserTitleIcon,
    url: '/users',
    roles: ['ROLE_ADMIN'],
  },
  /* {
      title: 'global.tenant',
      key: 'tenants',
      icon: TenantIcon,
      url: '/tenants',
    }, */
  {
    title: 'global.system',
    key: 'system',
    icon: SystemIcon,
    url: '/system',
    roles: ['ROLE_ADMIN'],
    children: [
      {
        title: 'menu.documents_template',
        key: 'system.documents_template',
        url: '/documents-template',
      },
      {
        title: 'menu.surveys',
        key: 'surveys',
        url: '/surveys',
      },
      {
        title: 'menu.options',
        key: 'system.options',
        // url: '/item-codes',
        onClick: () => {
          window.location.href = '/#/item-codes'
          window.location.reload()
        }
      },
      {
        title: 'menu.pipelines',
        key: 'system.pipeline',
        url: '/pipeline',
      },
      {
        title: 'menu.courses',
        key: 'courses',
        url: '/courses',
        settingsDependency: 'hasCourses',
      },
      {
        title: 'global.skills',
        key: 'system.Skills',
        url: '/skills',
      },
      {
        title: 'menu.backup',
        key: 'system.Backup',
        url: '/backups',
      },
      {
        title: 'global.tenant',
        key: 'system.tenantManagement',
        url: '/tenant-management',
        permission: 'users:read',
        tenantIds: [3, 83],
      },
    ],
  },
]


export const menuItemsOnlyCandidates = [
  {
    title: 'global.dashboard',
    key: 'home',
    icon: HomeIcon,
    url: '/candidates',
    permission: 'home',
  },
  {
    title: 'menu.nominatives',
    key: 'candidates',
    icon: CandidateIcon,
    url: '/candidates',
  },
  {
    title: 'menu.interview',
    key: 'interview',
    icon: InterviewTitleIcon,
    url: '/candidates-interview/0',
    permission: 'candidates:read',
    tenantIds: [340],
  },
  {
    title: 'menu.calendar',
    key: 'calendar',
    icon: CalendarDateIcon,
    url: '/calendar',
  },
]


export const settingsUrl = '#/settings'
export const profileUrl = '#/profile'
export const helpurl = 'https://documentation.performahrm.com/dashboard.htm'
